import React from 'react'
import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { LayoutDashboard, Users, ShoppingBag, Layers, FileText, LogOut } from 'lucide-react'
import { useAuth } from '../context/AuthContext'

export default function Layout() {
  const { profile, signOut } = useAuth()
  const navigate = useNavigate()

  async function handleSignOut() {
    await signOut()
    navigate('/login')
  }

  return (
    <div className="layout">
      <nav className="top-nav">
        <span className="top-nav-logo">Jackie's Tailor</span>
        {profile && <span className="top-nav-user">{profile.full_name?.split(' ')[0]}</span>}
        <button className="top-nav-btn" onClick={handleSignOut} title="Sign out">
          <LogOut size={18} />
        </button>
      </nav>

      <main className="page-content fade-in">
        <Outlet />
      </main>

      <nav className="bottom-nav">
        <NavLink to="/" end className={({isActive}) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <LayoutDashboard size={20} />
          Home
        </NavLink>
        <NavLink to="/clients" className={({isActive}) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <Users size={20} />
          Clients
        </NavLink>
        <NavLink to="/orders" className={({isActive}) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <ShoppingBag size={20} />
          Orders
        </NavLink>
        <NavLink to="/fabrics" className={({isActive}) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <Layers size={20} />
          Fabrics
        </NavLink>
        <NavLink to="/invoices" className={({isActive}) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <FileText size={20} />
          Invoices
        </NavLink>
      </nav>
    </div>
  )
}
